<script setup>
/* eslint-env vue/setup-compiler-macros */
import Tag from 'primevue/tag'
import { useI18n } from '@/i18n'

const props = defineProps({
  tags: { type: Array, default: () => [] }
})

const { t } = useI18n()
</script>

<template>
  <pFieldset v-if="props.tags.length" class="legend-transparent dashboard-widget">
    <template #legend>
      <div class="flex items-center pl-2">
        <span class="font-bold p-2">{{ t('siemWorkflowDetails.tags') }}</span>
      </div>
    </template>
    <div class="flex gap-2 flex-wrap">
      <Tag v-for="tag in props.tags" :key="tag" :value="tag" severity="secondary" />
    </div>
  </pFieldset>
</template>
